<template>
  <div class="page">
    <section class="section content-container">
      <div class="container is-fluid">
        <div class="report-container island">
          <ContactTrendCharts
            :data="data.newContactsTrendReport"
            :loadedData="loadedData"
            :loadingError="loadingError"
          />
        </div>
        <div class="report-container island">
          <ConversationTrendCharts
            :data="data.newConversationsTrendReport"
            :loadedData="loadedData"
            :loadingError="loadingError"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import { MessagingReportsData, messagingReportsApi } from '@/features/reports/services/messagingReportsApi';
import ContactTrendCharts from '@/features/reports/components/conversations/ContactTrendCharts.vue';
import ConversationTrendCharts from '@/features/reports/components/conversations/ConversationTrendCharts.vue';
import { SET_REPORT_LOADING } from '@/store/reports/mutationTypes';
import { useStore } from 'vuex';
import { computed, ref, watch } from 'vue';

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const selectedDateOption = computed(() => store.getters.selectedDateOption);

const setLoading = (loading: boolean) => store.commit(SET_REPORT_LOADING, loading);

const data = ref<MessagingReportsData>({});

const loadingError = ref(false);
const loadedData = ref(false);

watch(
  selectedDateOption,
  async (filter, previous) => {
    if (filter && filter === previous) {
      return;
    }

    await loadData();
  },
  { immediate: true },
);

async function loadData() {
  loadedData.value = false;
  loadingError.value = false;
  setLoading(true);
  try {
    data.value = await messagingReportsApi.loadReportData(currentWorkspace.value.id, {
      startDate: selectedDateOption.value.getDateRange().start,
      endDate: selectedDateOption.value.getDateRange().end,
      grouping: selectedDateOption.value.group,
    });
    loadedData.value = true;
  } catch {
    loadingError.value = true;
  } finally {
    setLoading(false);
  }
}
</script>

<style scoped lang="scss">
.island {
  height: 560px;
}

.report-container:not(:last-child) {
  margin-bottom: 1.5em;
}
</style>
